import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatSort} from '@angular/material/sort';
import {PageEvent} from '@angular/material/paginator';
import {KfRegistration} from '../../../../shared/models/kf-registration.interface';

@Component({
  selector: 'app-kf-registration-admin-table',
  templateUrl: './kf-registration-admin-table.component.html',
  styleUrls: ['./kf-registration-admin-table.component.scss']
})
export class KfRegistrationAdminTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['year', 'schemaKind', 'entry', 'keyFigures', 'b2bb2c', 'status', 'actions'];

  @Input()
  list!: KfRegistration[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadKfRegistrations: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor() { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadKfRegistrations.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadKfRegistrations.emit({page: event.pageIndex, size: event.pageSize});
  }

  getKeyFiguresUrlPart(kfRegistration: KfRegistration): string {
    return kfRegistration.keyFigures.replace(/ /gi, '').toLowerCase();
  }
}
